import { render, staticRenderFns } from "./RRApplicationLegalList.vue?vue&type=template&id=6a5368c6&scoped=true&"
import script from "./RRApplicationLegalList.vue?vue&type=script&lang=js&"
export * from "./RRApplicationLegalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5368c6",
  null
  
)

export default component.exports